// PATH: src/middleware/GhostGuard.jsx
import { Navigate, useOutlet } from "react-router";

import { useAuthContext } from "app/contexts/auth/context";
import { REDIRECT_URL_KEY } from "constants/app.constant";
import { hasValidSession } from "utils/session";

// only same-site paths allowed (blocks ?redirect=https://evil.com or //evil.com)
const getSafeRedirect = (value) => {
  if (typeof value !== "string") return null;
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return null;
  return value;
};

export default function GhostGuard() {
  const outlet = useOutlet();
  const { isAuthenticated } = useAuthContext();

  const redirectUrl = getSafeRedirect(
    new URLSearchParams(window.location.search).get(REDIRECT_URL_KEY),
  );

  // Already logged in = context says so AND cookies hold a valid session
  // (before: any access_token + email cookie, even expired / fake, bounced you)
  if (isAuthenticated && hasValidSession()) {
    return <Navigate to={redirectUrl || "/raajneeti/home"} replace />;
  }

  return <>{outlet}</>;
}